import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import CategoryEditIcon from "../../pages/categorySection/CategoryEditIcon"
import { getProductCatUrl } from "../../helpers/url";

const BannerOneSingle = ({ data, spaceBottomClass, dynamicBannerData }) => {

  return (
    <div className="antera-category-container categorySectionBanner" style={{
      width: dynamicBannerData.imageBoxSize ? (dynamicBannerData.imageBoxSize + "%") : "",
      marginRight: dynamicBannerData.spaceBetweenBox ? (dynamicBannerData.spaceBetweenBox + "%") : ""
    }}>
      <div
        className={`single-banner ${spaceBottomClass ? spaceBottomClass : ""} ${dynamicBannerData?.zoomInAnimation != false ? "zoomInAnimation" : ''}`}
      >
        <div className="edit-category-inline">
          <CategoryEditIcon editType={data.editType} />
        </div>
        <Link to={getProductCatUrl(data.link)} className="antera-category-image" style={{height:`${dynamicBannerData?.imageBoxHeight ? (dynamicBannerData.imageBoxHeight + "px") : ''}`}}>
          <img src={process.env.PUBLIC_URL + data.image} alt="" />
        </Link>
        <div className="antera-category-content-container banner-content">
          <h3 style={{ fontFamily: data.maintextFont, color: data.maintextColor, fontSize: (data.maintextFontSize + "px") }} dangerouslySetInnerHTML={{ __html: data.title }}></h3>
          <h4 style={{ fontFamily: data.textFont, color: data.textColor, fontSize: (data.textFontSize + "px") }} dangerouslySetInnerHTML={{ __html: data.subtitle }}>
          </h4>
          <span style={{ fontFamily: data.subtextFont, color: data.subtextColor, fontSize: (data.subtextFontSize + "px") }} dangerouslySetInnerHTML={{ __html: data.price }}></span>

          {dynamicBannerData?.showIcon && (data.title || data.image || data.price || data.subtitle) &&
            <div className={`${dynamicBannerData.linkIconAlign ? dynamicBannerData.linkIconAlign : ""}`} >
              <Link to={getProductCatUrl(data.link)}
                onMouseOver={(e) => {

                  e.target.style.borderColor = dynamicBannerData.iconHoverColor
                  e.target.style.color = dynamicBannerData.iconHoverColor ? dynamicBannerData.iconHoverColor : ""

                }}
                onMouseOut={(e) => {
                  e.target.style.borderColor = dynamicBannerData.iconColor
                  e.target.style.color = dynamicBannerData.iconColor ? dynamicBannerData.iconColor : ""
                }}
                style={{ color: dynamicBannerData.iconColor, borderColor: dynamicBannerData.iconColor }}
              >
                {dynamicBannerData.linkIcon != undefined && dynamicBannerData.linkIcon != "undefined" && dynamicBannerData.linkIcon != "" ? <i className={dynamicBannerData.linkIcon} /> : <i className="fa fa-long-arrow-right" />}
              </Link>
            </div>
          }

        </div>
      </div>
    </div>
  );
};

BannerOneSingle.propTypes = {
  data: PropTypes.object,
  spaceBottomClass: PropTypes.string,
  dynamicBannerData: PropTypes.any
};

export default BannerOneSingle;
